import $ from 'jquery';

export const init = () => {
	const jsQuestion = Array.from(document.querySelectorAll('.js-question'));

	function toggleContent() {
		event.stopPropagation();
		$(this).parent().find('.questions__answer').stop().slideToggle();
		$(this).toggleClass('is-open');
		$(this).parent().toggleClass('has-focus');
		if ($(this).hasClass('is-open')) {
			$(this).attr('aria-expanded', true);
			let dataLayerData = {
				event: 'accordionOpen',
				accordionName: $.trim($(this).text()),
			};
			dataLayer.push(dataLayerData);
		} else {
			$(this).attr('aria-expanded', false);
		}
	}

	// https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
	function toggleKeyboardContent() {
		event.stopPropagation();
		const target = event.target;
		const key = event.which.toString();
		// 33 = Page Up, 34 = Page Down
		const ctrlModifier = event.ctrlKey && key.match(/33|34/);
		const altModifier = event.altKey && key.match(/33|34/);

		// Is this coming from an accordion header?
		if (target.classList.contains('js-question')) {
			// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
			// 38 = Up, 40 = Down
			if (key.match(/38|40/) || ctrlModifier || altModifier) {
				const index = jsQuestion.indexOf(target);
				const direction = key.match(/34|40/) ? 1 : -1;
				const length = jsQuestion.length;
				const newIndex = (index + length + direction) % length;

				jsQuestion[newIndex].focus();

				event.preventDefault();
			} else if (key.match(/35|36/)) {
				// 35 = End, 36 = Home keyboard operations
				switch (key) {
					// Go to first accordion
					case '36':
						jsQuestion[0].focus();
						break;
					// Go to last accordion
					case '35':
						jsQuestion[jsQuestion.length - 1].focus();
						break;
				}
				event.preventDefault();
			}
		}
	}

	function showMore(e) {
		e.preventDefault();
		$(this).hide();
		const wrap = $(this).parents('.js-questions'),
			items = wrap.find('.js-questions-item');
		items.each(function () {
			$(this).fadeIn();
		});
	}

	function checkItems() {
		const wrap = $('.js-questions');
		if (wrap.length < 1) {
			return;
		}
		wrap.each(function () {
			const cols = $(this).find('.js-questions-cols'),
				list = $('.js-questions-list'),
				more = $(this).find('.js-questions-more');
			const amount = $(this).find('.js-questions-item').length;
			if (amount > 6) {
				more.removeClass('u-hide');
			}
		});
	}

	checkItems();
	$(document).on('click', '.js-questions-more', showMore);
	$(document).on('click', '.js-question', toggleContent);
	$(document).on('keydown', '.js-question', toggleKeyboardContent);
};
